<template>
  <v-card :style="style">
    <slot name="default"></slot>
    <v-card-title v-if="title">{{ title }}</v-card-title>
    <v-card-text class="text-card" v-html="content"></v-card-text>
  </v-card>
</template>
<style scoped>
.text-card :last-child {
  margin-bottom: 0
}
</style>
<script>
import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api'
export default {
  props: {
    section: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  setup (props, { root }) {
    const name = ref('')
    const title = ref('')
    const content = ref('')

    const style = ref('')

    const onPatchedListener = (data) => { if (data._id === props.id) loadBlock() }
    onMounted(() => { root.$feathers.service('orientation/block').on('patched', onPatchedListener) })
    onBeforeUnmount(() => { root.$feathers.service('orientation/block').removeListener('patched', onPatchedListener) })

    function loadBlock () {
      root.$feathers.service('orientation/block').get(props.id).then((data) => {
        name.value = data.name
        title.value = data.title
        content.value = data.content.replace(/<a /ig, '<a target="_blank"')

        if (root.$route.path.split('/')[1] !== 'admin') {
          if (name.value === 'Math Placement Test Final' || name.value === 'Foreign Language Placement Final' || name.value === 'World Languages Placement Final' || name.value === 'Music Theory Placement Final' || name.value === 'Writing Placement Test Final') {
            // default the visibility to false so it won't show the links until we verify which ones the student needs to see
            style.value = 'display:none'
            const { id, blocks } = root.$store.state.tracker
            // find the popup set block for the Placement Test Info
            for (let i = 0; i < blocks.length; i++) {
              if (blocks[i].section === 'placement' && blocks[i].items.length >= 3) {
                // For now we are assuming that a block in the tracker for Placements with an item count of at least 3 is the placement selection
                root.$feathers.service('orientation/block').get(blocks[i].block).then(({ items }) => {
                  let nameTemp = name.value.split(' ')
                  // Find the correct index number that matches the current item
                  for (let j = 0; j < items.length; j++) {
                    if (items[j].title.search(nameTemp[0]) >= 0) {
                      // Check and see if the item was checked or not
                      if (blocks[i].items[j].status === 'Y') {
                        style.value = ''
                        if (name.value === 'Writing Placement Test Final') {
                          root.$feathers.service('orientation/tracker').get(id).then((data) => {
                            let wpnVoucher = '--Not Assigned--'
                            if ('academics' in data && 'wpnVoucher' in data.academics) wpnVoucher = data.academics.wpnVoucher
                            content.value = content.value.replace('{{ Voucher }}', wpnVoucher)
                            content.value = content.value.replace('{{ Covenant Email }}', data.email)
                          })
                        }
                      }
                      break
                    }
                  }
                })
                break
              }
            }
          }
        }
      })
    }
    loadBlock()

    return {
      title,
      content,
      style
    }
  }
}
</script>
